import styled from 'styled-components';
export const Wrapper = styled.div `
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: 0 0 12px 3px ${({ theme }) => `rgba(${theme.colors.transparentBlack}, 0.2)`};
  position: relative;
`;
export const NavigationWrapper = styled.div `
  display: flex;
  justify-content: space-between;
  height: 6.25rem;
  align-items: center;
`;
export const IconsWrapper = styled.div `
  display: flex;
  button {
    span {
      display: flex;
      align-items: center;
      justify-content: center;
      svg {
        width: 1.25rem;
        height: 1.25rem;
      }
    }
  }
`;
export const NaviItemsWrapper = styled.div `
  display: flex;
  align-items: center;
`;
export const StyledNav = styled.nav `
  flex: 1;
  height: 100%;
`;
